import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

export default function TabSection({ labels, panels }) {
  return (
    <Tabs style={{ marginBottom: "1rem" }}>
      <TabList>
        {labels.map((label, i) => (
          <Tab key={i}>{label}</Tab>
        ))}
      </TabList>
      {panels.map((panel, i) => (
        <TabPanel key={i}>{panel}</TabPanel>
      ))}
    </Tabs>
  );
}
